import { GetServerSideProps } from 'next';
import Link from 'next/link';

import { Lia } from 'src/components/ui/Lia';
import { Text } from 'src/components/ui/Text';
import { Title } from 'src/components/ui/Title';
import { getCurrentContract } from 'src/services/PlatformAPI';
import { ContractType } from 'src/types';
import { ContractTypes } from 'src/utils/constants/types';
import { formatDateTime } from 'src/utils/date';

type BuyingTermsProps = {
  contract: ContractType;
};

export default function BuyingTerms(props: BuyingTermsProps) {
  return (
    <div className="mx-auto max-w-2xl p-5 sm:px-0 sm:py-20">
      <Lia />

      <Title
        size="xl"
        className="mt-10"
      >
        Termos e condições gerais de uso
      </Title>
      <Text
        size="sm"
        className="mb-10"
      >
        Data da última atualização: {formatDateTime(props.contract.updatedAt)}.
      </Text>

      <Text
        as="div"
        dangerouslySetInnerHTML={{ __html: props.contract.description }}
      />

      <footer className="mt-10 flex flex-col items-center justify-center gap-4 text-center sm:flex-row">
        <Link
          href="/politica-de-privacidade"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Política de privacidade
        </Link>
        <Link
          href="/politica-de-cookies"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Política de cookies
        </Link>
        <Link
          href="/termos-de-uso"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Termos de uso
        </Link>

        <Link
          href="/termos-de-contrato"
          className="text-foreground-subtle underline hover:text-foreground-main"
        >
          Termos de Contrato
        </Link>
      </footer>
    </div>
  );
}

export const getServerSideProps: GetServerSideProps = async () => {
  try {
    const contract = await getCurrentContract(ContractTypes.SERVICE, {});

    return {
      props: {
        contract,
      },
    };
  } catch (e) {
    if (e?.response?.status === 404) return { notFound: true };

    throw e;
  }
};
